/* =======================================================================
   CUSTOM ORDER : スタイル選択カルーセル（Shopify版）
   - 設計元 site/assets/js/customorder.js
   - 相違点はデータの持ち方のみ：MODELS を JS 直書きせず、
     sections/dw-page-customorder.liquid が custom-order コレクションから
     出力する window.DW_CUSTOM_MODELS を読む（商品追加が自動反映される）
   ※ build_theme_assets.py のコピー対象外。theme/ 側で手動管理する
   ======================================================================= */
(function () {
  'use strict';

  var MODELS = window.DW_CUSTOM_MODELS || [];

  if (typeof Swiper === 'undefined') { return; }
  if (!MODELS.length) { return; }

  var galEl      = document.querySelector('.co-gallery');
  var stylesRoot = document.querySelector('.co-styles');
  var stylesEl   = document.querySelector('.co-styles_carousel');
  if (!galEl || !stylesRoot || !stylesEl) { return; }

  var stylesWrap = stylesEl.querySelector('.swiper-wrapper');
  var gallery = null;
  var styleSwiper = null;
  var currentIdx = 0;

  function yen(n) { return '¥' + Number(n).toLocaleString('ja-JP'); }

  function gallerySlides(m) {
    var h = '';
    var imgs = m.images || [];
    for (var i = 0; i < imgs.length; i++) {
      h += '<div class="swiper-slide"><img class="co-gimg" src="' + imgs[i] + '" alt="' + m.name + ' ' + (i + 1) + '"></div>';
    }
    return h;
  }

  function initGallery(m) {
    if (gallery) { gallery.destroy(true, true); }
    galEl.querySelector('.swiper-wrapper').innerHTML = gallerySlides(m);
    gallery = new Swiper(galEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      // ステージが 1fr 1.05fr の小数幅になるため、スライド幅・移動量を
      // 整数に丸めて次スライドの端が1px覗くのを防ぐ
      roundLengths: true,
      autoplay: { delay: 4000, disableOnInteraction: false },
      pagination: { el: galEl.querySelector('.co-gallery_dots'), clickable: true }
    });
  }

  function selectModel(idx) {
    var m = MODELS[idx];
    if (!m) { return; }
    currentIdx = idx;

    document.querySelector('.co-info_en').textContent   = m.en;
    document.querySelector('.co-info_name').textContent = m.name;
    document.querySelector('.co-info_no').textContent   = m.model;
    document.querySelector('.co-info_sex').textContent  = m.sex;
    document.querySelector('.co-info_desc').textContent = m.detail;
    // 価格表記は言語ごとに Liquid から受け取る（¥19,800〜（税込） / From ¥19,800 (tax incl.)）
    var L = window.DW_CUSTOM_LABELS || {};
    var fmt = m.priceNote ? (L.priceRange || 'PRICE〜（税込）') : (L.priceFixed || 'PRICE（税込）');
    document.querySelector('.co-info_price').textContent = fmt.replace('PRICE', yen(m.price));

    var cards = stylesWrap.querySelectorAll('.co-style');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.toggle('is-current', i === idx);
    }

    if (styleSwiper) { styleSwiper.slideTo(idx); }
    initGallery(m);
  }

  // スタイル選択カード生成
  var cardsHtml = '';
  for (var i = 0; i < MODELS.length; i++) {
    var m = MODELS[i];
    cardsHtml +=
      '<div class="swiper-slide co-style" data-idx="' + i + '">' +
        '<div class="co-ph co-ph--thumb"><img src="' + (m.thumb || '') + '" alt="' + m.name + '"></div>' +
        '<p class="co-style_no">' + m.model + '</p>' +
        '<span class="co-style_badge">SELECTED</span>' +
      '</div>';
  }
  stylesWrap.innerHTML = cardsHtml;

  styleSwiper = new Swiper(stylesEl, {
    slidesPerView: 'auto',
    spaceBetween: 16,
    roundLengths: true,
    watchOverflow: true
  });

  // カードクリックで選択
  stylesWrap.addEventListener('click', function (e) {
    var card = e.target.closest ? e.target.closest('.co-style') : null;
    if (!card) { return; }
    selectModel(parseInt(card.getAttribute('data-idx'), 10));
  });

  // ステージ左右の大きな矢印で前後のスタイルへ切替（末端で循環）
  var navPrev = document.querySelector('.co-nav--prev');
  var navNext = document.querySelector('.co-nav--next');
  if (navPrev) {
    navPrev.addEventListener('click', function () {
      selectModel((currentIdx - 1 + MODELS.length) % MODELS.length);
    });
  }
  if (navNext) {
    navNext.addEventListener('click', function () {
      selectModel((currentIdx + 1) % MODELS.length);
    });
  }

  // SELECT → カスタム商品ページへ遷移（サイズはShopify商品ページで選択）
  document.querySelector('.co-select_btn').addEventListener('click', function (e) {
    e.preventDefault();
    window.location.href = MODELS[currentIdx].url;
  });

  // 初期表示
  selectModel(0);
})();
